import { render, staticRenderFns } from "./ConnectionInactiveDomains.vue?vue&type=template&id=e6e0c870"
import script from "./ConnectionInactiveDomains.vue?vue&type=script&lang=js"
export * from "./ConnectionInactiveDomains.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports